import { render, staticRenderFns } from "./domaine-louis-jadot.vue?vue&type=template&id=78705473&scoped=true"
import script from "./domaine-louis-jadot.vue?vue&type=script&lang=js"
export * from "./domaine-louis-jadot.vue?vue&type=script&lang=js"
import style0 from "./domaine-louis-jadot.vue?vue&type=style&index=0&id=78705473&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "78705473",
  null
  
)

export default component.exports